import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

function TaChart(props) {
  let opacity24;
  let opacity12;
  switch (props.highlight) {
    case "all":
      opacity12 = 1;
      opacity24 = 1;

      break;
    case "twentyfivesections":
      opacity12 = 0.5;
      opacity24 = 1;

      break;
    case "twelvesections":
      opacity12 = 1;
      opacity24 = 0.5;
      break;

    default:
      opacity12 = 1;
      opacity24 = 1;
      break;
  }
  return (
    <div style={{ width: "100%", height: 500 }}>
      <ResponsiveContainer>
        <BarChart
          width={800}
          height={500}
          data={props.data}
          style={{ display: "inline-block" }}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="key" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Bar
            dataKey="12 Sections Driver"
            fill="#0eb89a"
            fillOpacity={opacity12}
          />
          <Bar
            dataKey="24 Questions Driver"
            fill="#82ca9d"
            fillOpacity={opacity24}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TaChart;



// WEBPACK FOOTER //
// ./src/components/Charts/BarChart.js